import { render, staticRenderFns } from "./HomeMoreCard.vue?vue&type=template&id=45195d16&scoped=true&"
import script from "./HomeMoreCard.vue?vue&type=script&lang=js&"
export * from "./HomeMoreCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeMoreCard.vue?vue&type=style&index=0&id=45195d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45195d16",
  null
  
)

export default component.exports